import { ExtractPropTypes } from 'vue'
import type Switch from './switch.vue'

import { buildProps } from '@ll-plus/utils'

// props
export const switchProps = buildProps({
  // 选中时的文本
  checkedLabel: {
    type: String,
    default: '',
  },
  // 选中时的图标
  checkedIcon: {
    type: String,
    default: '',
  },
  // 未选中时的文本
  unCheckedLabel: {
    type: String,
    default: '',
  },
  // 未选中时的图标
  unCheckedIcon: {
    type: String,
    default: '',
  },
} as const)

// props
export type SwitchProps = ExtractPropTypes<typeof switchProps>

// instance
export type SwitchInstance = InstanceType<typeof Switch>
